<template>
	<!-- Button trigger modal -->
	<!-- Modal -->
	<div
		class="modal fade"
		:id="modal_id"
		tabindex="-1"
		role="dialog"
		aria-labelledby="exampleModalLabel"
		aria-hidden="true"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Track Order</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="container">
						<div class="row">
							<div class="col-md-12 col-lg-12">
								<div id="tracking-pre" v-if="!loading && error">
									<div class="product-not-found">
										<div class="not-found">
											<h2>SORRY!</h2>
											<h6>{{ error }}</h6>
										</div>
									</div>
								</div>
								<div id="tracking" v-if="!loading && !error">
									<div class="text-center tracking-status-intransit">
										<p class="tracking-status text-tight">
											{{ getCurrentStatus }}
										</p>
									</div>
									<div class="tracking-list">
										<div class="tracking-item" v-if="getShipmentStatus != 7">
											<div class="tracking-icon status-intransit bg-dark">
												<i class="fas fa-map"></i>
											</div>
											<div class="tracking-date" :class="{'error-order': getShipmentStatus == 8}">
												{{ formatDate(getEstimatedDeliveryDate)
												}}<span> {{ formatTime(getEstimatedDeliveryDate) }}</span>
											</div>
											<div class="tracking-content" :class="{'error-order': getShipmentStatus == 8}">
												Estimated Delivery Date
												<span> {{ getDestination }}</span>
											</div>
										</div>
										<div
											class="tracking-item"
											v-for="(
												shipment_track_activity, index
											) in tracking_data.shipment_track_activities"
											:key="index"
										>
											<div class="tracking-icon status-intransit bg-dark">
												<i class="fas fa-map"></i>
											</div>

											<div class="tracking-date">
												{{ formatDate(shipment_track_activity.date)
												}}<span> {{ formatTime(shipment_track_activity.date) }}</span>
											</div>
											<div class="tracking-content">
												{{ shipment_track_activity.activity
												}}<span>{{ shipment_track_activity.location }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="button button-primary mt-4" data-dismiss="modal">
						Close
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import moment from "moment";
	export default {
		props: ["modal_id", "order_id"],
		computed: {
			getCurrentStatus: function () {
				return this.tracking_data.shipment_track[0].current_status;
			},
			getEstimatedDeliveryDate: function () {
				return this.tracking_data.shipment_track[0].edd;
			},
			getDestination: function () {
				return (
					this.tracking_data.shipment_track[0].consignee_name +
					" - " +
					this.tracking_data.shipment_track[0].destination
				);
			},
			getShipmentStatus: function () {
				return this.tracking_data.shipment_status;
			},
		},
		data() {
			return {
				tracking_data: {},
				loading: true,
				error: null,
			};
		},
		mounted() {
			console.log("Track Order Modal Mounted");
			this.getTrackingDetailsByOrderId();
		},
		methods: {
			formatDate(date) {
				return moment(date).format("MMMM Do YYYY");
			},
			formatTime(date) {
				return moment(date).format("h:mm:ss a");
			},

			async getTrackingDetailsByOrderId() {
				this.loading = true;
				const token = process.env.VUE_APP_SHIPROCKET_API_KEY;
				const url = `${process.env.VUE_APP_API_URL}/api/tracking-details/${this.order_id}`;
				try {
					const {data} = await axios.get(url);
					if (data.length != 0 && data[0] != false) {
						this.tracking_data = data[0].tracking_data;
					} else {
						this.error = "No tracking data found";
					}
					console.log(data);
					this.loading = false;
				} catch (error) {
					this.loading = false;
					this.error = error;
				}
			},
		},
	};
</script>

<style scoped>
	.modal-body {
		overflow-y: scroll;
	}
	.tracking-detail {
		padding: 3rem 0;
	}
	#tracking {
		margin-bottom: 1rem;
	}
	[class*="tracking-status-"] p {
		margin: 0;
		font-size: 1.1rem;
		color: #fff;
		text-transform: uppercase;
		text-align: center;
	}
	[class*="tracking-status-"] {
		padding: 1.6rem 0;
	}
	.tracking-status-intransit {
		background-color: #343a40;
	}
	.tracking-status-outfordelivery {
		background-color: #f5a551;
	}
	.tracking-status-deliveryoffice {
		background-color: #f7dc6f;
	}
	.tracking-status-delivered {
		background-color: #4cbb87;
	}
	.tracking-status-attemptfail {
		background-color: #b789c7;
	}
	.tracking-list {
		border: 1px solid #e5e5e5;
	}
	.tracking-item {
		border-left: 1px solid #e5e5e5;
		position: relative;
		padding: 2rem 1.5rem 0.5rem 2.5rem;
		font-size: 0.9rem;
		margin-left: 3rem;
		min-height: 5rem;
	}
	.tracking-item:last-child {
		padding-bottom: 4rem;
	}
	.tracking-item .tracking-date {
		margin-bottom: 0.5rem;
	}
	.tracking-item .tracking-date span {
		color: #888;
		font-size: 85%;
		padding-left: 0.4rem;
	}
	.tracking-item .tracking-content {
		padding: 0.5rem 0.8rem;
		background-color: #f4f4f4;
		border-radius: 0.5rem;
	}
	.tracking-item .tracking-content span {
		display: block;
		color: #888;
		font-size: 85%;
	}
	.tracking-item .tracking-icon {
		line-height: 2.6rem;
		position: absolute;
		left: -1.3rem;
		width: 2.6rem;
		height: 2.6rem;
		text-align: center;
		border-radius: 50%;
		font-size: 1.1rem;
		background-color: #fff;
		color: #fff;
	}
	.tracking-item .tracking-icon.status-intransit {
		color: #e5e5e5;
		border: 1px solid #e5e5e5;
		font-size: 1rem;
	}
	@media (min-width: 992px) {
		.tracking-item {
			margin-left: 10rem;
		}
		.tracking-item .tracking-date {
			position: absolute;
			left: -10rem;
			width: 7.5rem;
			text-align: right;
		}
		.tracking-item .tracking-date span {
			display: block;
		}
		.tracking-item .tracking-content {
			padding: 0;
			background-color: transparent;
		}
		.error-order {
			text-decoration: line-through;
		}
		.product-not-found {
			height: 300px;
			min-height: 300px;
		}
	}
</style>
